import { createFileRoute } from '@tanstack/react-router';
import { VisitMonitorPage } from '@/modules/visit-monitor/visit-monitor-page';

/**
 * `?f=` is the encoded filter selection. The filters module writes it with
 * `history.replaceState`, but it still has to be declared here — otherwise a
 * router navigation would validate it away and drop the user's filters.
 */
interface VisitMonitorSearch {
  f?: string;
}

export const Route = createFileRoute('/_auth/visit-monitor')({
  validateSearch: (search: Record<string, unknown>): VisitMonitorSearch => ({
    f: typeof search.f === 'string' ? search.f : undefined,
  }),
  component: VisitMonitorPage,
});
